var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForgotArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1864 1.48027C11.1399 1.4337 11.0847 1.39676 11.024 1.37156C10.9632 1.34635 10.8981 1.33337 10.8324 1.33337C10.7666 1.33337 10.7015 1.34635 10.6407 1.37156C10.58 1.39676 10.5248 1.4337 10.4784 1.48027L4.47836 7.48027C4.43179 7.52671 4.39485 7.58189 4.36964 7.64263C4.34444 7.70338 4.33146 7.7685 4.33146 7.83427C4.33146 7.90003 4.34444 7.96516 4.36964 8.0259C4.39485 8.08665 4.43179 8.14182 4.47836 8.18827L10.4784 14.1883C10.5722 14.2822 10.6996 14.3349 10.8324 14.3349C10.9651 14.3349 11.0925 14.2822 11.1864 14.1883C11.2802 14.0944 11.333 13.967 11.333 13.8343C11.333 13.7015 11.2802 13.5742 11.1864 13.4803L5.53936 7.83427L11.1864 2.18827C11.2329 2.14182 11.2699 2.08665 11.2951 2.0259C11.3203 1.96516 11.3333 1.90004 11.3333 1.83427C11.3333 1.7685 11.3203 1.70338 11.2951 1.64263C11.2699 1.58189 11.2329 1.52671 11.1864 1.48027Z",
    fill: "#0C3B5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotArrow);
export default __webpack_public_path__ + "static/media/forgot-arrow.e458179c6ec25e0a2422df85e47640c4.svg";
export { ForwardRef as ReactComponent };